import React, { useEffect, useState } from "react";
 import MetaTags from "react-meta-tags";
import {
    Container,
    Row,
} from "reactstrap";
import BuildingForm from "../BuildingForm"
const EditBuilding = (props) => {
  const id=props.match.params.id
 
    return (
        <>
            <div className='page-content'>
                <MetaTags>
                    <title>Building</title>
                </MetaTags>
                <Container fluid>
                    <Row >
                    <h4>Add New Building</h4>
                    </Row>
                  <BuildingForm  compoundId={id} fromParams={true}  history={props.history}/>
                </Container>
            </div>
        </>
    )
}

export default EditBuilding